import React, { useCallback, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { ArtifactMintingList, MintButton } from '@pkg/components';
import { useAppDispatch, useAppSelector } from '@pkg/hooks';

import { ArtifactMintSteps, ArtifactType } from '@app/client/common/structs/nft/artifacts';
import { PathParams } from '@app/routes/types';
import { setArtifactMintPanelStep } from '@app/store/actions/artifacts';
import { artifactUrlToKeyMap } from '@app/store/types/artifacts';

import '../ArtifactMintPanel.scss';

export const SelectArtifact = () => {
    const { t } = useTranslation(['artifacts', 'words']);

    const { [PathParams.ArtifactType]: artifactType } = useParams();
    const { selectedArtifact } = useAppSelector((state) => state.artifacts);
    const [disabled, setDisabled] = useState(true);
    const dispatch = useAppDispatch();

    const currentArtifactType = artifactUrlToKeyMap.get(artifactType as string);

    useEffect(() => {
        if (artifactType === ArtifactType.CelestialRose) {
            setDisabled(!selectedArtifact?.id);
        } else {
            setDisabled(!selectedArtifact?.artifactId);
        }
    }, [artifactType, selectedArtifact]);

    const onNext = useCallback(() => {
        dispatch(setArtifactMintPanelStep(ArtifactMintSteps.Introduction));
    }, [dispatch]);

    return (
        <div className="yat-artifact-sidebar__step">
            {currentArtifactType && (
                <>
                    <ArtifactMintingList artifactType={currentArtifactType} />
                    <MintButton
                        copy={t('cta_select_copy')}
                        hoverCopy={t('cta_select_hover_copy')}
                        disabled={disabled}
                        onClick={onNext}
                    />
                </>
            )}
        </div>
    );
};
